import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {MatOptionSelectionChange} from '@angular/material/core';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {PSQIResults, Q_PSQI} from '../../../../model/questionnaires/questionnaire-psqi';

@Component({
  selector: 'app-questionnaire-psqi',
  templateUrl: './questionnaire-psqi.component.html',
  styleUrls: ['./questionnaire-psqi.component.css']
})
export class QuestionnairePsqiComponent implements OnInit {

  qForm: FormGroup;
  dataSource = Q_PSQI;
  notFocused = false;
  submitted = false;
  show = false;
  displayedColumns = ['position', 'question', 'value'];
  results = [];
  q = 'question';
  found = false;

  /// toolbar
  back = true;
  destination = '/questionnaires';
  title = 'PSQI';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;

  constructor(private questionnaireService: QuestionnaireService,
              public dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    this.qForm = new FormGroup({
      question1hour: new FormControl({value: ''}, [Validators.required, Validators.min(0), Validators.max(23)]),
      question1minute: new FormControl({value: ''}, [Validators.required, Validators.min(0), Validators.max(59)]),
      question2: new FormControl({value: ''}, [Validators.required, Validators.min(0)]),
      question3hour: new FormControl({value: ''}, [Validators.required, Validators.min(0), Validators.max(23)]),
      question3minute: new FormControl({value: ''}, [Validators.required, Validators.min(0), Validators.max(59)]),
      question4: new FormControl({value: ''}, [Validators.required, Validators.min(0)]),
      question15: new FormControl({value: ''}),
    });
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.dataSource.length + 1; ++i) {
      this.results.push(null);
    }

    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
    this.qForm.get('question15').setValue(null);
  }

  selectResult($event: MatOptionSelectionChange, value: string, position: number, answers: string[]) {
    if ($event.isUserInput) {
      this.results[position - 1] = value;

      if (position === 14 && this.results[position - 1] === 'No') {
        this.results[position] = null;
        this.results[position + 1] = null;
        console.log('Setteeddd');
      }

      console.log('Risposta: ', value);
      console.log('Risultati: ', this.results);
    }
  }

  setResult(position: number) {
    const question = 'question' + position;
    // tslint:disable-next-line:max-line-length
    if ((position === 1 || position === 3) && (this.qForm.get(question + 'hour').value >= 0 && this.qForm.get(question + 'minute').value >= 0))  {

      let res = '';
      if (this.qForm.get(question + 'hour').value < 10) {
        res += '0';
      }
      res += this.qForm.get(question + 'hour').value.toString() + ':';
      if (this.qForm.get(question + 'minute').value < 10) {
        res += '0';
      }
      res += this.qForm.get(question + 'minute').value.toString();

      this.results[position - 1] = res;

    } else if (position === 2 || position === 4) {
      this.results[position - 1] = this.qForm.get(question).value.toString();
      console.log('Ecco');
    } else if (position === 14 && this.results[position - 1] === 'Si (specificare)') {
      if (this.qForm.get('question15').value !== '' && this.qForm.get('question15').value !== null) {
        this.results[position] = this.qForm.get('question15').value.toString();
      } else {
          this.results[position] = null;
        }
    }

    console.log(this.results);
  }

  onSubmit() {
    this.submitted = true;
    this.show = true;
    this.found = false;

    if (this.results.length !== this.dataSource.length + 1) {
      this.show = false;
      this.submitted = false;
      this.found = true;
      const msg = 'Non hai finito di completare il questionario!';
      this.openErrorDialog(msg);
    } else {
        for (let i = 0; i < this.results.length; i++) {
          if (i !== 14 && i !== 15) {
            if (this.results[i] === null) {
              this.show = false;
              this.submitted = false;
              this.found = true;
              const msg = 'Non hai finito di completare il questionario!';
              this.openErrorDialog(msg);
              break;
            }
          }
          if (i === 13) {
            if (this.results[i] !== null && this.results[i] !== 'No') {
              if (this.results[i + 1] === null || this.results[i + 2] === null) {
                  this.show = false;
                  this.submitted = false;
                  this.found = true;
                  const msg = 'Non hai finito di completare il questionario!';
                  this.openErrorDialog(msg);
                  break;
              }
            }
          }
      }

        if (!this.found) {
          const resultToSend = new PSQIResults(this.doctorID, this.patientSSN, this.results);
          this.questionnaireService.sendForm(resultToSend, 'psqi', this.uuid);
      }
    }
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }

}
